<template>
	<div class="performance">
		<Title :zhTitle="pageData.name" :enTitle="pageData.name"></Title>
		<div class="cards-blue" v-if="theme == 'blue' || theme == 'yellow'" :style="prHitData.length == 3 || prHitData.length == 5 ? '' : 'justify-content: center;'">
			<div class="card-blue" v-for="(item, index) in prHitData" :key="index">
				<div class="number">
					<span v-if="index < 9">0{{ index + 1 }}</span><span v-else>{{ index + 1 }}</span>
				</div>
				<div :class="[language === 'zh' ? 'zh_text' : 'en_text']">{{ item.content }}</div>
			</div>
		</div>
		<div class="cards" v-else :style="prHitData.length == 3 || prHitData.length == 5 ? '' : 'justify-content: center;'">
			<div class="card" :class="'card' + index" v-for="(item, index) in prHitData" :key="index">
				<div class="index">
					<span v-if="index < 9">0{{ index + 1 }}</span><span v-else>{{ index + 1 }}</span>
				</div>
				<div :class="[language === 'zh' ? 'zh_text' : 'en_text']">{{ item.content }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import Title from '@/components/title.vue'
import { mapState } from 'vuex'

export default {
	name: 'Performance',
	components: {
		Title,
	},
	props: {
		index: {
			type: Number,
		},
	},
	data() {
		return {
			pageData: {},
      prHitData: [],
		}
	},
	computed: {
		...mapState(['theme', 'language', 'jsonData']),
	},
  watch:{
    language(newVal, oldVal) {
      this.initData();
    }
  },
	mounted() {
    this.initData();
	},
	methods: {
    initData() {
      let data = JSON.parse(this.jsonData.moduleData)
      if (this.language == 'zh') { // 根据语言获取相应数据
        data = JSON.parse(this.jsonData.moduleData)
        this.prHitData = JSON.parse(this.jsonData.prHit)
      } else {
        data = JSON.parse(this.jsonData.moduleDataEng)
        this.prHitData = JSON.parse(this.jsonData.prHitEng)
      }
      this.pageData = data[this.index]
    }
  },
}
</script>

<style lang="scss" scoped>
.red {
	.performance {
		margin-top: 14px;
		width: 1040px;
		height: 503px;
		position: relative;
		background: #ffffff;
		box-shadow: 2px 2px 10px 6px rgba(211, 47, 46, 0.07);
    border: 1px solid rgba(211, 47, 46, 0.07);
    box-sizing: border-box;
	}
}

.purple {
	.performance {
		margin-top: 14px;
		width: 1040px;
		height: 503px;
		position: relative;
		background: #ffffff;
		box-shadow: 2px 2px 10px 6px rgba(211, 47, 46, 0.07);
    border: 1px solid rgba(211, 47, 46, 0.07);
	}
}

.cards {
	margin-top: 24px;
	padding: 0 66px;
	display: flex;
	flex-wrap: wrap;
	//justify-content: flex-start; /* 控制主轴上的对齐方式 */
	//align-items: stretch; /* 控制交叉轴上的对齐方式 */
	gap: 24px 113px; /* 在Flexbox布局中，使用gap属性来设置元素之间的间隔 */
  min-height: 340px;
  align-items: center;
}

.card {
	position: relative;
	height: 96px;
  width: 390px;
	border-radius: 8px;
	border: 1px solid var(--baseColor);
	//flex: 1 0 40%; /* 控制子元素如何分配空间，这里表示每个元素占据容器宽度的50% */
	display: flex;
	align-items: center;
}

.index {
	position: absolute;
	top: 20px;
	left: -29px;
	width: 58px;
	height: 58px;
	border-radius: 100%;
	background: var(--baseColor);
	text-align: center;
	font-size: 28px;
	font-weight: 400;
	color: #ffffff;
	line-height: 58px;
}

.zh_text {
	margin-left: 58px;
	margin-right: 15px;
	font-size: 16px;
	font-weight: 400;
	color: var(--timeTitleColor);
	line-height: 22px;

	display: -webkit-box;
	-webkit-line-clamp: 3; /* 设置显示的行数 */
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis; /* 超出部分显示省略号 */
}
.en_text {
	margin-left: 44px;
	margin-right: 15px;
	font-size: 14px;
	font-weight: 400;
	color: var(--timeTitleColor);
	line-height: 20px;

	display: -webkit-box;
	-webkit-line-clamp: 4; /* 设置显示的行数 */
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis; /* 超出部分显示省略号 */
}

.purple {
	.card0,
	.card3 {
		border: none;
		background: rgba(139, 202, 234, 0.16);
		.index {
			background: #8bcaea;
		}
	}
	.card1,
	.card4 {
		border: none;
		background: rgba(249, 205, 112, 0.16);
		.index {
			background: #f9cd70;
		}
	}
	.card2,
	.card5 {
		border: none;
		background: rgba(243, 173, 191, 0.16);
		.index {
			background: #f3adbf;
		}
	}
}
.blue {
	.performance {
		padding: 0 80px;
		padding-top: 27px;
		width: 980px;
		height: 489px;
		position: relative;
	}
	.cards-blue {
		margin-top: 38px;
    min-height: 340px;
		display: flex;
		flex-wrap: wrap;
    //height: 362px;
    //align-items: center; // 垂直居中
		//justify-content: flex-start; /* 控制主轴上的对齐方式 */
		//align-items: center; /* 控制交叉轴上的对齐方式 */
		gap: 34px 120px; /* 在Flexbox布局中，使用gap属性来设置元素之间的间隔 */
	}
	.card-blue {
		width: 428px;
		height: 98px;
		background: #ecf2fd;
		border-radius: 8px;
		display: flex;
		align-items: center;
	}
	.number {
		width: 44px;
		height: 104px;
		background: linear-gradient(90deg, #4782ea 0%, #5db6fc 100%);
		border-radius: 8px 0px 0px 8px;

		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: 600;
		font-size: 24px;
		color: #ffffff;
		line-height: 33px;
	}

	.zh_text {
		margin-left: 15px;
		margin-right: 15px;
		width: 355px;
		font-size: 16px;
		font-weight: 400;
		color: var(--timeTitleColor);
		line-height: 22px;

		display: -webkit-box;
		-webkit-line-clamp: 3; /* 设置显示的行数 */
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis; /* 超出部分显示省略号 */
	}
	.en_text {
		margin-left: 16px;
		margin-right: 15px;
		width: 355px;
		font-size: 14px;
		font-weight: 400;
		color: var(--timeTitleColor);
		line-height: 20px;

		white-space: normal;
		word-wrap: break-word;
		overflow-wrap: break-word;
		word-break: break-word;
		display: -webkit-box;
		-webkit-line-clamp: 4; /* 设置显示的行数 */
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis; /* 超出部分显示省略号 */
	}
}
.yellow {
	.performance {
		width: 980px;
		height: 510px;
		padding: 0 80px;
		background: #f5f6f8;
		border-radius: 28px;
		position: relative;
	}
	.cards-blue {
		margin-top: 29px;
    min-height: 340px;
		display: flex;
		flex-wrap: wrap;
		//justify-content: flex-start; /* 控制主轴上的对齐方式 */
		//align-items: stretch; /* 控制交叉轴上的对齐方式 */
		gap: 40px 124px; /* 在Flexbox布局中，使用gap属性来设置元素之间的间隔 */
	}
	.card-blue {
		width: 428px;
		height: 98px;
		background: #ffffff;
		box-shadow: 6px 2px 9px 0px rgba(165, 165, 165, 0.2);
		border-radius: 8px;
		display: flex;
		align-items: center;
	}
	.number {
		width: 44px;
		height: 104px;
		background: #f8bc27;
		border-radius: 8px 0px 0px 8px;

		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: 600;
		font-size: 24px;
		color: #151517;
		line-height: 33px;
	}

	.zh_text {
		margin-left: 15px;
		margin-right: 15px;
		width: 355px;
		font-size: 16px;
		font-weight: 400;
		color: var(--timeTitleColor);
		line-height: 22px;

		display: -webkit-box;
		-webkit-line-clamp: 3; /* 设置显示的行数 */
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis; /* 超出部分显示省略号 */
	}
	.en_text {
		margin-left: 16px;
		margin-right: 15px;
		width: 355px;
		font-size: 14px;
		font-weight: 400;
		color: var(--timeTitleColor);
		line-height: 20px;

		white-space: normal;
		word-wrap: break-word;
		overflow-wrap: break-word;
		word-break: break-word;
		display: -webkit-box;
		-webkit-line-clamp: 4; /* 设置显示的行数 */
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis; /* 超出部分显示省略号 */
	}
}
</style>
